import { render } from "./SingleAgentMonitoringView.vue?vue&type=template&id=0bd5650c&scoped=true"
import script from "./SingleAgentMonitoringView.vue?vue&type=script&lang=js"
export * from "./SingleAgentMonitoringView.vue?vue&type=script&lang=js"

import "./SingleAgentMonitoringView.vue?vue&type=style&index=0&id=0bd5650c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd5650c"]])

export default __exports__